import { gql } from "@apollo/client";

const UPDATE_TOR_COMPONENT_TABLE_C = gql`
    mutation updateToRComponentTableC($componentID: String!, $laID: String!, $componentCode: String!, $componentTitle: String!, $gradeReceived: String, $ects: String!, $successfullyCompleted: Boolean, $semester: String){
      updateToRComponentTableC(componentID: $componentID, laID: $laID, componentCode: $componentCode, componentTitle: $componentTitle, gradeReceived: $gradeReceived, ects: $ects, successfullyCompleted: $successfullyCompleted, semester: $semester)
  }
`;

export default UPDATE_TOR_COMPONENT_TABLE_C;
